import AreaTemplate from '../AreaTemplate';

const schema = {
  '@context': 'https://schema.org',
  '@type': 'ElectricalContractor',
  name: 'Electrician Solutions Fresno — Madera',
  description: 'Licensed electrician serving Madera, CA. C-10 certified electrical contractor for residential and commercial electrical work in Madera County.',
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Madera',
    addressRegion: 'CA',
    postalCode: '93637',
    addressCountry: 'US',
  },
  geo: { '@type': 'GeoCoordinates', latitude: '36.9613', longitude: '-120.0607' },
  url: 'https://electriciansolutionsfresno.com/areas/madera',
  telephone: '+1-559-123-4567',
  priceRange: '$$',
  areaServed: { '@type': 'City', name: 'Madera', '@id': 'https://en.wikipedia.org/wiki/Madera,_California' },
};

const faqs = [
  {
    q: 'Do you provide electrician services in Madera, CA?',
    a: 'Yes! Electrician Solutions Fresno serves all of Madera, CA with full residential and commercial electrical services. Our C-10 licensed electricians handle everything from panel upgrades and rewiring to EV charger installations and smart home automation throughout Madera County.',
  },
  {
    q: 'How quickly can you respond to emergencies in Madera?',
    a: 'We offer 24/7 emergency electrical services in Madera with response times typically under 60 minutes from our Fresno base. We cover all of Madera including downtown, the Avenue 12 corridor, and surrounding rural properties.',
  },
  {
    q: 'Do Madera electrical projects require City permits?',
    a: 'Yes. The City of Madera Building and Safety Division requires permits for panel upgrades, new circuits, and rewiring work. We handle all Madera City permits and Madera County permits for rural properties as part of every project.',
  },
  {
    q: 'Can you upgrade an older home panel in Madera?',
    a: 'Absolutely. Many Madera homes have older 100A panels that need upgrading to support modern appliances, EV chargers, and AC systems in the hot Central Valley climate. We upgrade to 200A or 400A service, including all Madera City permits.',
  },
  {
    q: 'What neighborhoods in Madera do you serve?',
    a: 'We cover all Madera neighborhoods including downtown Madera, Westside Madera, North Madera, the Gateway Drive corridor, Lake Van Ness area, and rural Madera County properties. We also service the Madera Ranchos unincorporated area.',
  },
  {
    q: 'Do you install solar-ready wiring in Madera?',
    a: 'Yes. With Madera County receiving 280+ sunny days per year, solar is an excellent investment. We install solar-ready panels, battery storage pre-wiring, and EV charging circuits for Madera homeowners looking to reduce their PG&E bills.',
  },
];

const MaderaPage = () => (
  <AreaTemplate
    area="Madera"
    areaSlug="madera"
    state="CA"
    county="Madera County"
    population="66,000+"
    description="Electrician Solutions Fresno brings professional C-10 licensed electrical services to all of Madera, CA and Madera County. From the historic downtown district to new residential developments along the Highway 99 corridor, our certified Madera electricians provide safe, code-compliant electrical solutions for homes, farms, and businesses throughout the region."
    neighborhoods={['Downtown Madera', 'Westside Madera', 'North Madera', 'Gateway Corridor', 'Lake Van Ness', 'Madera Ranchos', 'Avenue 12 Area', 'Southeast Madera']}
    nearbyAreas={[
      { name: 'Fresno', slug: 'fresno' },
      { name: 'Clovis', slug: 'clovis' },
      { name: 'Selma', slug: 'selma' },
      { name: 'Dinuba', slug: 'dinuba' },
      { name: 'Visalia', slug: 'visalia' },
    ]}
    faqs={faqs}
    heroImage="https://public.readdy.ai/ai/img_res/1da69c991e8e1a93ac6d78c70d94232c.jpg"
    heroImageAlt="Licensed Electrician in Madera CA"
    teamImage="https://readdy.ai/api/search-image?query=Professional%20electrician%20crew%20in%20branded%20uniforms%20posing%20confidently%20outside%20a%20Madera%20California%20residential%20neighborhood%20with%20agriculture%20fields%20and%20blue%20Central%20Valley%20sky%20in%20background%20showing%20community%20involvement%20and%20local%20expertise&width=800&height=600&seq=madera_team_001&orientation=landscape"
    teamImageAlt="Electrician Solutions team serving Madera CA"
    schema={schema}
  />
);

export default MaderaPage;
